// React
import { useEffect, useState } from "react"

// Types
import type { AccountHookType, SelectOptionType, SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

export function useAccounts(): AccountHookType {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    refetch()
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  function refetch() {
    setLoading(true)

    api.get("/spendmoney/coacheque").then((res: SuccessFetch<{
      payload: {
        coa_id: number
        coa_code: string
        coa_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: `${item.coa_code} ${item.coa_name}`,
          value: item.coa_id.toString()
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  }

  return { data, isLoading, refetch }
}